export default __webpack_public_path__ + "static/media/5.e6c00216.png";